import * as yup from 'yup';
import { companyPeriodRequestViewModelFields } from './company-period-request.view-model';

export function companyPeriodRequestGridSchema() {
  return yup.object({
    ...companyPeriodRequestViewModelFields(),
    actions: yup.string().label(''),
  });
}

export type CompanyPeriodRequestGridViewModel = yup.InferType<
  ReturnType<typeof companyPeriodRequestGridSchema>
>;
